import { QueryClient } from '@tanstack/react-query';

/**
 * Cache unique des données du site. Exporté pour pouvoir le VIDER à chaque changement de société (ou de compte) :
 * les clés de requête ne portent pas la société, donc sans ce vidage une page pouvait réafficher les chiffres de la
 * société précédente (constaté le 20/10/2026 : « Arriérés de salaire » à 0 F pour SIM GROUP).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry:              1,
      refetchOnWindowFocus: false,
      staleTime:          30_000,
    },
  },
});

/** Oublie toutes les données chargées : chaque page les redemandera pour la société (ou le compte) en cours. */
export const oublierDonnees = () => queryClient.clear();
